import React from "react";
import COLORS from "./styleConstants";
var BaseIcon = function BaseIcon(_ref) {
  var color = _ref.color,
    //    _ref$pushRight = _ref.pushRight,
    //  pushRight = _ref$pushRight === undefined ? true : _ref$pushRight,
    //  pushRight = false

    children = _ref.children;
  return React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: color,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      style: { float: "left", minWidth: 24, marginRight: "10px" },
    },
    children
  );
};

var InfoIcon = function InfoIcon() {
  return React.createElement(
    BaseIcon,
    { color: "white" },
    React.createElement("circle", { cx: "12", cy: "12", r: "10" }),
    React.createElement("line", { x1: "12", y1: "16", x2: "12", y2: "12" }),
    React.createElement("line", { x1: "12", y1: "8", x2: "12", y2: "8" })
  );
};

var SuccessIcon = function SuccessIcon() {
  return React.createElement(
    BaseIcon,
    //  { color: "#31B404" },
    { color: "white" },

    React.createElement("path", { d: "M22 11.08V12a10 10 0 1 1-5.93-9.14" }),
    React.createElement("polyline", { points: "22 4 12 14.01 9 11.01" })
  );
};

var ErrorIcon = function ErrorIcon() {
  return React.createElement(
    BaseIcon,
    { color: "white" },
    React.createElement("circle", { cx: "12", cy: "12", r: "10" }),
    React.createElement("line", { x1: "12", y1: "8", x2: "12", y2: "12" }),
    React.createElement("line", { x1: "12", y1: "16", x2: "12", y2: "16" })
  );
};

var CloseIcon = function CloseIcon() {
  return React.createElement(
    BaseIcon,
    { color: "#FFFFFF", pushRight: false },
    React.createElement("line", { x1: "18", y1: "6", x2: "6", y2: "18" }),
    React.createElement("line", { x1: "6", y1: "6", x2: "18", y2: "18" })
  );
};

var _extends =
  Object.assign ||
  function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

export var alertStyle = {
  backgroundColor: "#A8C046",
  color: "white",
  minWidth: 350,
  borderRadius: "3px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexGrow: "1 1 100%",
  boxShadow: "0px 2px 2px 2px rgba(0, 0, 0, 0.03)",
  boxSizing: "border-box",
  fontFamily: "Aaux Next",
  fontWeightx: "bold",
  fontSize: "14pt",
  minHeight: "40px",
  textAlign: "center",
  alignItems: "center",
  overflow: "visible",
  opacity: "1",
  borderColor: "black",
};

var alertStyleInfo = {
  ...alertStyle,
  backgroundColor: COLORS.info,
};

var alertStyleError = {
  ...alertStyle,
  backgroundColor: COLORS.error,
};

const alertColorSuccess = COLORS.orange;
const alertColorInfo = COLORS.blue;

var AlertTemplate = function AlertTemplate(_ref) {
  var message = _ref.message,
    options = _ref.options,
    style = _ref.style,
    close = _ref.close;

  var backgroundColor = (COLORS.grey = "");
  if (options.type === "error") {
    backgroundColor = COLORS.error;
  } else if (options.type === "info") {
    backgroundColor = COLORS.info;
  } else if (options.type === "warning") {
    backgroundColor = COLORS.warning;
  } else {
    backgroundColor = COLORS.success;
  }

  var buttonStyle = {
    marginxLeft: "20px",
    border: "none",
    backgroundColor: backgroundColor,
    cursor: "pointer",
    color: "white",
    float: "right",
  };
  style = { display: "flex", alignItems: "center" };
  return React.createElement(
    "div",
    {
      style: _extends(
        {},

        options.type === "error"
          ? alertStyleError
          : options.type === "info"
          ? alertStyleInfo
          : alertStyle,
        style
      ),
    },
    options.type === "info" && React.createElement(InfoIcon, null),
    options.type === "success" && React.createElement(SuccessIcon, null),
    options.type === "error" && React.createElement(ErrorIcon, null),
    React.createElement(
      "span",
      { style: { display: "flex", alignItems: "center" } },
      message
    ),

    React.createElement(
      "button",
      { onClick: close, style: buttonStyle },
      React.createElement(CloseIcon, null)
    )
  );
};

export default AlertTemplate;
